export default [
    {   //包材管理
        path: "setting/material",
        name: "settingMaterial",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/setting/material/index"),
    },
    {   //事务处理项设置
        path: "setting/transaction",
        name: "settingtTransaction",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/setting/transaction/index"),
    },
    {   //商品管理
        path: "setting/productmanage",
        name: "settingtProductmanage",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/setting/productmanage/index"),
    },
    // 限额分配
    // 组织限额分配
    {  
        path: "setting/limitallot/organization",
        name: "settingtLimitOrg",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/setting/limitallot/organization/index"),
    },

    // 仓库限额分配
    {   
        path: "setting/limitallot/warehouse",
        name: "settingtLimitWarehouse",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/setting/limitallot/warehouse/index"),
    },
    // 限额占用明细
    {   
        path: "setting/limitallot/takeup",
        name: "settingtLimitTakeup",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/setting/limitallot/takeup/index"),
    },
    // 预留单
    {   
        path: "setting/reserved/list",
        name: "settingReservedList",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/setting/reserved/index"),
    },
    {   
        path: "setting/reserved/update/:type",
        name: "settingReservedUpdate",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/setting/reserved/update"),
    },
]


